import React, { useCallback } from 'react';
import { Maximize2 } from 'lucide-react';
import PDFViewer from './PDFViewer';
import './PdfPane.css';

const PdfPane = ({ pdfData, currentPage, onPageChange, mode, onExpand }) => {
  const isReading = mode === 'reading';

  const handlePaneClick = useCallback(
    (e) => {
      if (!isReading || !onExpand) return;

      const target = e.target;
      if (
        target.closest('button') ||
        target.closest('input') ||
        target.closest('.pdf-controls') ||
        target.closest('.pdf-zoom-controls')
      ) {
        return;
      }

      onExpand();
    },
    [isReading, onExpand]
  );

  return (
    <section
      className={[
        'viewer-section',
        'pdf-pane',
        isReading ? 'pdf-pane--preview' : '',
      ].join(' ')}
      onClick={handlePaneClick}
      aria-label="PDF Pane"
    >
      {isReading ? (
        <div className="pdf-pane__floating">
          <button
            type="button"
            className="pdf-pane__expand-btn"
            onClick={(e) => {
              e.stopPropagation();
              onExpand?.();
            }}
            title="Expandir PDF"
          >
            <Maximize2 size={16} />
            <span>Expandir</span>
          </button>
          <div className="pdf-pane__hint">Clique no PDF para expandir</div>
        </div>
      ) : null}

      <PDFViewer
        pdfData={pdfData}
        currentPage={currentPage}
        onPageChange={onPageChange}
      />
    </section>
  );
};

export default PdfPane;
